<template>
  <div>
    <form ref="netopiaPaymentRedirect" method="post" :action="mobilPay.formAction">
      <input type="hidden" name="env_key" :value="mobilPay.formFieelds.env_key" />
      <input type="hidden" name="data" :value="mobilPay.formFieelds.data" />
    </form>

    <button type="submit" 
          dsav-show="!loading" 
          @click="loadData();"
          class="
              block
              sm:flex sm:items-center
              px-4
              py-3
              rounded
              font-bold
              text-sm
              cursor-pointer
              bg-green-500
              text-white
              hover:bg-green-400
              text-center
              w-full
              sm:w-auto
              mt-4
              sm:mt-0
            ">
        <span>
          <i class="fas fa-credit-card"></i>&nbsp;{{ $t("common.pay-now") }}
        </span>
      </button>
  </div>
</template>

<script>

import axios from "axios";

export default {
  props: {
    data: Object,
  },
  mounted(){
    
  },
  data() {
    return {
      loading: true,
      mobilPay: {
        formAction: '',
        formFieelds:{
          env_key: '',
          data: ''
        }
      }
    };
  },
  methods: {
    async loadData() {
      // var url = this.route('payment.netopia.card-redirect-form');
      var url = '/shop/payment/netopia/card-redirect';
      console.log(url)
      await axios({
          method: "get",
          url: url,
        }).then(
          (response) => {
            //success
            this.mobilPay = response.data;
            if(!response.data.error){
              var form = this.$refs.netopiaPaymentRedirect;
              setTimeout(function(){
                form.submit()
              },10);

            }
            this.loading = false;
          },
          (error) => {
            if (typeof error.response !== "undefined") {
              if (error.response.data) {
                if (error.response.data.errors) {
                  // component.errors = error.response.data.errors;
                  console.error(error.response.data.errors);
                }

                if (error.response.data.message) {
                  console.error(error.response.data.message);
                }
              }
            }
            this.$toastr.e(error.message, this.$t("common.save-error-title"));
          }
        );



        // return new Promise(async (resolve, reject) => {
        //     try {
        //         const response = await axios.get(this.route('payment.netopia.card-redirect-form'));

        //         resolve(response.data);
        //     } catch (exception) {
        //         reject(exception);
        //     }
        // });
    }
  },
};
</script>
